import ApiService from "./ApiService"

export async function getSettings (data) {
    return ApiService.fetchData({
        url: '/settings/getSettings',
        method: 'get',
        data
    })
}

export async function updateSettings (data) {
    return ApiService.fetchData({
        url: '/settings/updateSettings',
        method: 'post',
        data
    })
}